import type { CSSProperties, HTMLAttributes } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import './DraggableRow.scss';

type TDraggableBodyRowProps = HTMLAttributes<HTMLTableRowElement> & {
  'data-row-key': string;
};

const DraggableBodyRow = (props: TDraggableBodyRowProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    activeIndex,
    overIndex,
    isOver,
    isDragging,
  } = useSortable({
    id: props['data-row-key'],
  });

  const style: CSSProperties = {
    ...props.style,
    transform: CSS.Translate.toString(transform),
    transition,
    cursor: 'move',
    ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
  };

  const dropClassName =
    activeIndex < overIndex ? 'drop-over-downward' : 'drop-over-upward';
  const className = `${props.className || ''} ${isOver ? dropClassName : ''}`;

  return (
    <tr
      ref={setNodeRef}
      {...props}
      className={className}
      style={style}
      {...attributes}
      {...listeners}
    />
  );
};
export default DraggableBodyRow;
